var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEntradaFacil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 898,
    height: 296,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#30236a",
    d: "m106.21499,24.82501l-52.5,0c-10.3,0 -18.66,8.35 -18.66,18.66l0,54.94c0,4.09 3.32,7.41 7.41,7.41l63.75,0c4.09,0 7.41,-3.32 7.41,-7.41l0,-66.19c0,-4.09 -3.32,-7.41 -7.41,-7.41zm-12.15,51.45c0,5.19 -4.21,9.4 -9.4,9.4l-20.67,0c-5.19,0 -9.4,-4.21 -9.4,-9.4l0,-21.89c0,-5.19 4.21,-9.4 9.4,-9.4l20.67,0c5.19,0 9.4,4.21 9.4,9.4l0,21.89z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#30236a",
    d: "m254.33499,24.82501l-53.41,0c-4.59,0 -8.32,3.72 -8.32,8.32l0,49.3c0,12.91 10.47,23.38 23.38,23.38l47,0c4.52,0 8.18,-3.66 8.18,-8.18l0,-55.98c0,-9.3 -7.54,-16.84 -16.84,-16.84l0.01,0zm-2.71,51.45c0,5.19 -4.21,9.4 -9.4,9.4l-20.67,0c-5.19,0 -9.4,-4.21 -9.4,-9.4l0,-21.89c0,-5.19 4.21,-9.4 9.4,-9.4l20.67,0c5.19,0 9.4,4.21 9.4,9.4l0,21.89z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#30236a",
    d: "m175.05499,29.64501l0,11.06c0,2.66 -2.16,4.81 -4.81,4.81l-13.18,0c-2.66,0 -4.81,2.16 -4.81,4.81l0,12.24c0,2.66 -2.16,4.81 -4.81,4.81l-10.12,0c-2.66,0 -4.81,-2.16 -4.81,-4.81l0,-29.53c0,-4.54 3.68,-8.22 8.22,-8.22l29.53,0c2.66,0 4.81,2.16 4.81,4.81l-0.02,0.02z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#30236a",
    d: "m175.05499,269.26501l0,-11.06c0,-2.66 -2.16,-4.81 -4.81,-4.81l-13.18,0c-2.66,0 -4.81,-2.16 -4.81,-4.81l0,-12.24c0,-2.66 -2.16,-4.81 -4.81,-4.81l-10.12,0c-2.66,0 -4.81,2.16 -4.81,4.81l0,29.53c0,4.54 3.68,8.22 8.22,8.22l29.53,0c2.66,0 4.81,-2.16 4.81,-4.81l-0.02,-0.02z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "#30236a",
    d: "m271.17499,269.26501l0,-11.06c0,-2.66 -2.16,-4.81 -4.81,-4.81l-31.1,0c-2.66,0 -4.81,-2.16 -4.81,-4.81l0,-12.24c0,-2.66 -2.16,-4.81 -4.81,-4.81l-28.21,0c-2.66,0 -4.81,2.16 -4.81,4.81l0,29.53c0,4.54 3.68,8.22 8.22,8.22l65.53,0c2.66,0 4.81,-2.16 4.81,-4.81l0,-0.02l-0.01,0z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_6",
    fill: "#30236a",
    ry: 5.74,
    rx: 5.74,
    height: 28.56,
    width: 19.75,
    y: 206.64501,
    x: 251.42499,
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    fill: "#1ad272",
    d: "m222.26499,159.14501c-12.93,12.93 -51.73,51.73 -51.73,51.73c-4.24,4.24 -11.13,4.24 -15.37,0s-4.25,-11.14 0,-15.38l33.16,-33.17l-83.64,0c-5.87,0 -10.62,-4.75 -10.62,-10.61l0,-0.52c0,-5.87 4.75,-10.62 10.62,-10.62l83.63,0l-33.15,-33.16c-4.25,-4.25 -4.25,-11.13 0,-15.38c2.12,-2.12 4.9,-3.19 7.68,-3.19s5.57,1.07 7.69,3.19c0,0 38.79,38.81 51.73,51.73c4.25,4.24 4.25,11.13 0,15.38l0,0z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    fill: "#30236a",
    d: "m106.20499,193.07501l-45.66,0c-3.28,0 -5.94,-2.66 -5.94,-5.94l0,-58.78c0,-3.29 -2.67,-5.96 -5.96,-5.96l-7.69,0c-3.26,0 -5.9,2.64 -5.9,5.9l0,130.43c0,8.47 6.87,15.34 15.34,15.34l55.82,0c4.09,0 7.4,-3.31 7.4,-7.4l0,-66.19c0,-4.09 -3.32,-7.41 -7.41,-7.41l0,0l0,0.01zm-12.14,51.45c0,5.19 -4.21,9.4 -9.4,9.4l-20.67,0c-5.19,0 -9.4,-4.21 -9.4,-9.4l0,-21.89c0,-5.19 4.21,-9.4 9.4,-9.4l20.67,0c5.19,0 9.4,4.21 9.4,9.4l0,21.89z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_9",
    isolation: "isolate",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_10",
    fill: "#30236a",
    d: "m307.93499,24.76501l67.89,0l0,19.67l-45.37,0l0,21.73l33.47,0l0,18.72l-33.47,0l0,23.48l45.37,0l0,19.51l-67.89,0l0,-103.11z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_11",
    fill: "#30236a",
    d: "m413.89499,127.87501l-22.21,0l0,-78.52l20.46,0l0,14.59c4.44,-11.1 13.17,-16.5 24.9,-16.5c21.26,0 29.35,14.75 29.35,34.58l0,45.84l-22.21,0l0,-44.58c0,-10.15 -4.76,-16.18 -14.75,-16.18s-15.55,6.19 -15.55,16.5l0,44.26l0.01,0.01z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_12",
    fill: "#30236a",
    d: "m512.40499,67.43501l0,32.36c0,7.3 3.33,10.63 8.41,10.63c3.81,0 6.82,-1.27 10.95,-4.44l9.2,15.39c-7.3,6.03 -15.39,8.41 -23.64,8.41c-16.02,0 -27.13,-9.52 -27.13,-29.98l0,-32.36l-13.01,0l0,-18.08l13.96,0l4.6,-17.77l16.66,0l0,17.77l22.68,0l0,18.08l-22.68,0l0,-0.01z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_13",
    isolation: "isolate",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_14",
    fill: "#30236a",
    d: "m574.58499,127.87501l-22.21,0l0,-78.52l20.3,0l0,16.82c3.97,-12.53 12.21,-18.72 22.84,-18.72c3.33,0 6.03,0.63 8.09,1.75l-3.81,21.42c-2.54,-0.63 -5.39,-0.95 -7.93,-0.95c-10.47,0 -17.29,3.17 -17.29,16.66l0,41.56l0.01,-0.02z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_15",
    isolation: "isolate",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_16",
    fill: "#30236a",
    d: "m661.82499,116.77501c-5.23,9.04 -14.59,13.01 -24.43,13.01c-15.86,0 -27.29,-9.52 -27.29,-24.27c0,-13.8 9.99,-22.53 26.49,-22.53l19.83,0c2.86,0 3.65,-0.95 3.65,-3.33l0,-1.11c0,-8.57 -5.08,-13.33 -12.37,-13.33s-11.9,4.28 -14.44,11.42l-20.15,-4.92c4.76,-14.91 17.61,-24.27 34.58,-24.27c22.05,0 34.26,12.53 34.26,34.11l0,46.32l-20.15,0l0,-11.1l0.02,0zm-1.74,-18.25l0,-1.59l-18.56,0c-6.82,0 -9.68,3.17 -9.68,7.93c0,5.39 4.12,8.41 10.79,8.41c9.52,0 17.45,-5.55 17.45,-14.75z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_17",
    fill: "#30236a",
    d: "m755.09499,113.91501c-4.6,11.42 -13.17,15.86 -24.27,15.86c-20.46,0 -34.42,-17.61 -34.42,-41.08s13.96,-41.24 34.42,-41.24c10.47,0 18.72,3.65 23.64,12.85l0,-40.29l21.57,0l0,107.87l-20.94,0l0,-13.96l0,-0.01zm-1.27,-25.22c0,-13.33 -6.03,-22.84 -17.45,-22.84s-17.45,9.52 -17.45,22.84s6.03,22.68 17.45,22.68s17.45,-9.36 17.45,-22.68z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_18",
    fill: "#30236a",
    d: "m842.81499,116.77501c-5.23,9.04 -14.59,13.01 -24.43,13.01c-15.86,0 -27.29,-9.52 -27.29,-24.27c0,-13.8 9.99,-22.53 26.49,-22.53l19.83,0c2.86,0 3.65,-0.95 3.65,-3.33l0,-1.11c0,-8.57 -5.08,-13.33 -12.37,-13.33s-11.9,4.28 -14.44,11.42l-20.15,-4.92c4.76,-14.91 17.61,-24.27 34.58,-24.27c22.05,0 34.26,12.53 34.26,34.11l0,46.32l-20.15,0l0,-11.1l0.02,0zm-1.74,-18.25l0,-1.59l-18.56,0c-6.82,0 -9.68,3.17 -9.68,7.93c0,5.39 4.12,8.41 10.79,8.41c9.52,0 17.45,-5.55 17.45,-14.75z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_19",
    isolation: "isolate",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_20",
    fill: "#1ad272",
    d: "m330.61499,234.41501l0,39.66l-22.68,0l0,-103.11l66.62,0l0,19.67l-43.94,0l0,24.11l33.31,0l0,19.67l-33.31,0z",
    className: "st1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_21",
    isolation: "isolate",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_22",
    fill: "#1ad272",
    d: "m427.53499,262.97501c-5.23,9.04 -14.59,13.01 -24.43,13.01c-15.86,0 -27.28,-9.52 -27.28,-24.27c0,-13.8 9.99,-22.53 26.49,-22.53l19.83,0c2.85,0 3.65,-0.95 3.65,-3.33l0,-1.11c0,-8.57 -5.08,-13.33 -12.37,-13.33s-11.9,4.28 -14.44,11.42l-20.15,-4.92c4.76,-14.91 17.61,-24.27 34.58,-24.27c22.05,0 34.26,12.53 34.26,34.11l0,46.32l-20.15,0l0,-11.1l0.01,0zm-35.85,-88.52l40.29,-13.01l4.28,18.08l-41.08,9.04l-3.49,-14.12l0,0.01zm34.11,70.27l0,-1.59l-18.56,0c-6.82,0 -9.68,3.17 -9.68,7.93c0,5.39 4.12,8.41 10.79,8.41c9.52,0 17.45,-5.55 17.45,-14.75z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_23",
    fill: "#1ad272",
    d: "m484.48499,234.89501c0,14.28 6.82,22.68 17.61,22.68c7.46,0 12.21,-3.17 16.02,-10.15l18.56,6.66c-5.55,12.69 -17.29,21.89 -35.69,21.89c-23.48,0 -39.18,-17.29 -39.18,-41.08c0,-25.06 17.45,-41.24 39.97,-41.24c16.97,0 28.24,8.57 34.11,20.94l-17.61,9.04c-4.12,-7.61 -8.72,-11.58 -16.18,-11.58c-10.31,0 -17.61,8.41 -17.61,22.84z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_24",
    fill: "#1ad272",
    d: "m547.13499,171.59501c0,-7.3 6.19,-13.01 13.64,-13.01s13.8,5.71 13.8,13.01s-6.19,13.17 -13.8,13.17s-13.64,-5.87 -13.64,-13.17zm24.75,102.48l-22.21,0l0,-78.52l22.21,0l0,78.52z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_25",
    fill: "#1ad272",
    d: "m614.24499,274.07501l-22.21,0l0,-107.87l22.21,0l0,107.87z",
    className: "st1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntradaFacil);
export default __webpack_public_path__ + "static/media/entrada-facil.7f5426239b4b737983eea9ebff8d5b2c.svg";
export { ForwardRef as ReactComponent };